// import {
// 	Box,
// 	VStack,
// 	HStack,
// 	Text,
// 	Progress,
// 	Badge,
// 	IconButton,
// 	Collapse,
// 	useDisclosure,
// } from '@chakra-ui/react';
// import { CloseIcon, ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
// import { useSelector, useDispatch } from 'react-redux';
// import {
// 	selectAllCampaigns,
// 	removeCampaign,
// } from '../../redux/whatsappCampaignSlice';

// const statusColor = {
// 	running: 'blue',
// 	completed: 'green',
// 	error: 'red',
// };

// const CampaignCard = ({ campaign }) => {
// 	const dispatch = useDispatch();
// 	const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: true });

// 	return (
// 		<Box
// 			border='1px solid'
// 			borderColor='gray.200'
// 			borderRadius='lg'
// 			p={3}
// 			bg='white'
// 			shadow='sm'
// 			minW='300px'
// 		>
// 			<HStack justify='space-between' mb={2}>
// 				<HStack spacing={2}>
// 					<Badge colorScheme={statusColor[campaign.status]} fontSize='xs'>
// 						{campaign.status}
// 					</Badge>
// 					<Text fontSize='xs' color='gray.500' fontFamily='mono'>
// 						{campaign.id.slice(0, 8)}…
// 					</Text>
// 				</HStack>
// 				<HStack>
// 					<IconButton
// 						icon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
// 						size='xs'
// 						variant='ghost'
// 						onClick={onToggle}
// 						aria-label='toggle'
// 					/>
// 					{campaign.status !== 'running' && (
// 						<IconButton
// 							icon={<CloseIcon />}
// 							size='xs'
// 							variant='ghost'
// 							colorScheme='gray'
// 							onClick={() => dispatch(removeCampaign(campaign.id))}
// 							aria-label='dismiss'
// 						/>
// 					)}
// 				</HStack>
// 			</HStack>

// 			<Collapse in={isOpen}>
// 				<Progress
// 					value={campaign.percentage}
// 					colorScheme={statusColor[campaign.status]}
// 					size='sm'
// 					w='100%'
// 					borderRadius='full'
// 					mb={2}
// 					hasStripe={campaign.status === 'running'}
// 					isAnimated={campaign.status === 'running'}
// 				/>
// 				<HStack justify='space-between' fontSize='xs' color='gray.600'>
// 					<Text>✅ {campaign.sent} sent</Text>
// 					<Text>❌ {campaign.failed} failed</Text>
// 					<Text fontWeight='500'>{campaign.percentage}%</Text>
// 				</HStack>
// 				<Text fontSize='xs' color='gray.400' mt={1}>
// 					Total: {campaign.total} messages
// 				</Text>

// 				{campaign.failedNumbers?.length > 0 && (
// 					<Box mt={2} maxH='60px' overflowY='auto'>
// 						{campaign.failedNumbers.map((f, i) => (
// 							<Text key={i} fontSize='xs' color='red.400'>
// 								{f.phone}: {f.error}
// 							</Text>
// 						))}
// 					</Box>
// 				)}
// 			</Collapse>
// 		</Box>
// 	);
// };

// // This is the floating panel — put it in App.jsx or a layout component
// export const WhatsappCampaignProgressPanel = () => {
// 	// useCampaignSSE(); // starts/stops SSE connections automatically

// 	const campaigns = useSelector(selectAllCampaigns);
// 	if (campaigns.length === 0) return null;

// 	// console.log(campaigns);

// 	return (
// 		<Box position='fixed' bottom={4} right={4} zIndex={999}>
// 			<VStack spacing={2} align='stretch'>
// 				{campaigns.map((c) => (
// 					<CampaignCard key={c.id} campaign={c} />
// 				))}
// 			</VStack>
// 		</Box>
// 	);
// };

import {
	Box,
	VStack,
	HStack,
	Text,
	Progress,
	Badge,
	IconButton,
	Collapse,
	useDisclosure,
	Spinner,
	Tooltip,
	Heading,
	Divider,
	Button,
	useToast,
	Link,
} from '@chakra-ui/react';
import {
	CloseIcon,
	ChevronDownIcon,
	ChevronUpIcon,
	CheckCircleIcon,
	WarningTwoIcon,
	InfoOutlineIcon,
	CopyIcon,
	DeleteIcon,
} from '@chakra-ui/icons';
import { useSelector, useDispatch } from 'react-redux';
import {
	selectAllCampaigns,
	removeCampaign,
} from '../../redux/whatsappCampaignSlice';
import { toast } from 'react-toastify';

const statusColor = {
	running: 'blue',
	completed: 'green',
	error: 'red',
};

const statusIcon = {
	running: Spinner,
	completed: CheckCircleIcon,
	error: WarningTwoIcon,
};

// Helper to truncate campaign ID with better readability
const formatCampaignId = (id) => {
	if (!id) return '';
	const parts = id.split('-');
	if (parts.length === 5) {
		return `${parts[0].slice(0, 6)}…${parts[4]}`;
	}
	return `${id.slice(0, 8)}…${id.slice(-4)}`;
};

const CampaignCard = ({ campaign }) => {
	const dispatch = useDispatch();
	const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: true });
	const StatusIcon = statusIcon[campaign.status] || InfoOutlineIcon;

	// Determine progress bar color based on status and percentage
	const progressColorScheme =
		campaign.status === 'completed'
			? 'green'
			: campaign.status === 'error'
				? 'red'
				: 'blue';

	return (
		<Box
			borderWidth='1px'
			borderColor='gray.100'
			borderRadius='xl'
			p={4}
			bg='white'
			shadow='lg'
			transition='all 0.2s'
			_hover={{
				shadow: 'xl',
				borderColor: 'gray.200',
				transform: 'translateY(-2px)',
			}}
			position='relative'
			overflow='hidden'
		>
			{/* Animated gradient border for running campaigns */}
			{campaign.status === 'running' && (
				<Box
					position='absolute'
					top={0}
					left={0}
					right={0}
					height='3px'
					bgGradient='linear(to-r, blue.300, blue.500, blue.300)'
					animation='pulse 2s infinite'
					sx={{
						'@keyframes pulse': {
							'0%': { opacity: 0.6 },
							'50%': { opacity: 1 },
							'100%': { opacity: 0.6 },
						},
					}}
				/>
			)}

			<VStack align='stretch' spacing={3}>
				{/* Header Section */}
				<HStack justify='space-between'>
					<HStack spacing={2}>
						{/* Status Icon with Tooltip */}
						<Tooltip label={`Status: ${campaign.status}`} placement='top'>
							<Box>
								{campaign.status === 'running' ? (
									<Spinner size='xs' color='blue.500' />
								) : (
									<StatusIcon
										boxSize={4}
										color={
											campaign.status === 'completed' ? 'green.500' : 'red.500'
										}
									/>
								)}
							</Box>
						</Tooltip>

						<Badge
							colorScheme={statusColor[campaign.status]}
							fontSize='xs'
							px={2}
							py={0.5}
							borderRadius='full'
							textTransform='capitalize'
						>
							{campaign.status}
						</Badge>

						<Tooltip label={campaign.id} placement='top'>
							<HStack spacing={1}>
								<Text fontSize='xs' color='gray.500' fontFamily='mono'>
									{formatCampaignId(campaign.id)}
								</Text>
							</HStack>
						</Tooltip>
					</HStack>

					<HStack spacing={1}>
						<Tooltip label={isOpen ? 'Collapse details' : 'Expand details'}>
							<IconButton
								icon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
								size='xs'
								variant='ghost'
								onClick={onToggle}
								aria-label='toggle details'
							/>
						</Tooltip>
						{campaign.status !== 'running' && (
							<Tooltip label='Remove campaign'>
								<IconButton
									icon={<CloseIcon boxSize={2.5} />}
									size='xs'
									variant='ghost'
									colorScheme='gray'
									onClick={() => dispatch(removeCampaign(campaign.id))}
									aria-label='dismiss campaign'
								/>
							</Tooltip>
						)}
					</HStack>
				</HStack>

				{/* Progress Section */}
				<Collapse in={isOpen}>
					<VStack align='stretch' spacing={3}>
						{/* Main Progress Bar */}
						<Box>
							<Progress
								value={campaign.percentage}
								colorScheme={progressColorScheme}
								size='sm'
								w='100%'
								borderRadius='full'
								hasStripe={campaign.status === 'running'}
								isAnimated={campaign.status === 'running'}
								bg='gray.100'
							/>
						</Box>

						{/* Stats Grid */}
						<HStack justify='space-between' spacing={4}>
							<VStack align='flex-start' spacing={0}>
								<HStack spacing={1}>
									<CheckCircleIcon boxSize={3} color='green.500' />
									<Text fontSize='xs' fontWeight='medium'>
										Sent
									</Text>
								</HStack>
								<Text fontSize='lg' fontWeight='bold' lineHeight={1.2}>
									{campaign.sent}
								</Text>
							</VStack>

							<VStack align='flex-start' spacing={0}>
								<HStack spacing={1}>
									<WarningTwoIcon boxSize={3} color='red.500' />
									<Text fontSize='xs' fontWeight='medium'>
										Failed
									</Text>
								</HStack>
								<Text fontSize='lg' fontWeight='bold' lineHeight={1.2}>
									{campaign.failed}
								</Text>
							</VStack>

							<VStack align='flex-end' spacing={0}>
								<Text fontSize='xs' fontWeight='medium' color='gray.500'>
									Progress
								</Text>
								<Text fontSize='lg' fontWeight='bold' lineHeight={1.2}>
									{campaign.percentage}%
								</Text>
							</VStack>
						</HStack>

						{/* Total Messages */}
						<Text fontSize='xs' color='gray.500' textAlign='center'>
							Total: {campaign.total} messages
						</Text>

						{/* Failed Numbers List */}
						{campaign.failedNumbers?.length > 0 && (
							<Box
								mt={1}
								maxH='100px'
								overflowY='auto'
								bg='red.50'
								borderRadius='md'
								p={2}
								borderWidth='1px'
								borderColor='red.100'
							>
								<HStack spacing={1} mb={1}>
									<WarningTwoIcon boxSize={3} color='red.600' />
									<Text fontSize='xs' fontWeight='semibold' color='red.800'>
										Failed Details ({campaign.failedNumbers.length})
									</Text>
								</HStack>
								<VStack align='stretch' spacing={1}>
									{campaign.failedNumbers.map((f, i) => (
										<HStack key={i} spacing={1}>
											<Text fontSize='xs' color='red.700' fontFamily='mono'>
												{f.phone}:
											</Text>
											<Text fontSize='xs' color='red.600' flex={1}>
												{f.error}
											</Text>
										</HStack>
									))}
								</VStack>
							</Box>
						)}

						{/* Estimated completion time for running campaigns */}
						{campaign.status === 'running' && campaign.percentage < 100 && (
							<Text fontSize='xs' color='gray.400' textAlign='center'>
								• Sending in progress •
							</Text>
						)}
					</VStack>
				</Collapse>
			</VStack>
		</Box>
	);
};

// Main Floating Panel Component
export const WhatsappCampaignProgressPanel = () => {
	const campaigns = useSelector(selectAllCampaigns);
	const dispatch = useDispatch();
	const { isOpen: isPanelOpen, onToggle: onPanelToggle } = useDisclosure({
		defaultIsOpen: true,
	});

	if (campaigns.length === 0) return null;

	const activeCampaigns = campaigns.filter(
		(c) => c.status === 'running',
	).length;
	const completedCampaigns = campaigns.filter(
		(c) => c.status === 'completed',
	).length;
	const errorCampaigns = campaigns.filter((c) => c.status === 'error').length;

	const handleClearCompleted = () => {
		const completedOrError = campaigns.filter((c) => c.status !== 'running');
		if (completedOrError.length === 0) {
			toast.error('Only completed or failed campaigns can be removed');
			return;
		}
		completedOrError.forEach((campaign) => {
			dispatch(removeCampaign(campaign.id));
		});
		toast.success(`Removed ${completedOrError.length} finished campaigns`);
	};

	return (
		<Box
			position='fixed'
			bottom={4}
			right={4}
			zIndex={999}
			maxW={{ base: 'calc(100vw - 32px)', sm: '400px', md: '480px' }}
			w='full'
		>
			<Box
				bg='white'
				borderRadius='2xl'
				shadow='2xl'
				overflow='hidden'
				transition='all 0.3s ease'
				borderWidth='1px'
				borderColor='gray.100'
			>
				{/* Panel Header */}
				<Box
					bgGradient='linear(to-r, gray.50, white)'
					px={4}
					py={3}
					borderBottomWidth='1px'
					borderBottomColor='gray.100'
				>
					<HStack justify='space-between'>
						<HStack spacing={2}>
							<Heading size='sm' fontWeight='semibold' color='gray.700'>
								WhatsApp Campaigns
							</Heading>
							<Badge
								colorScheme={activeCampaigns > 0 ? 'blue' : 'gray'}
								borderRadius='full'
								px={2}
							>
								{activeCampaigns} active
							</Badge>
						</HStack>

						<HStack spacing={1}>
							{/* Clear completed button */}
							{(completedCampaigns > 0 || errorCampaigns > 0) && (
								<Tooltip label='Remove all completed & failed campaigns'>
									<IconButton
										icon={<DeleteIcon />}
										size='xs'
										variant='ghost'
										colorScheme='red'
										onClick={handleClearCompleted}
										aria-label='clear completed campaigns'
									/>
								</Tooltip>
							)}

							{/* Panel collapse button */}
							<Tooltip label={isPanelOpen ? 'Minimize panel' : 'Expand panel'}>
								<IconButton
									icon={isPanelOpen ? <ChevronDownIcon /> : <ChevronUpIcon />}
									size='xs'
									variant='ghost'
									onClick={onPanelToggle}
									aria-label='toggle panel'
								/>
							</Tooltip>
						</HStack>
					</HStack>

					{/* Summary stats */}
					{(completedCampaigns > 0 || errorCampaigns > 0) && (
						<HStack spacing={3} mt={2} fontSize='xs' color='gray.500'>
							{completedCampaigns > 0 && (
								<HStack spacing={1}>
									<CheckCircleIcon boxSize={3} color='green.500' />
									<Text>{completedCampaigns} completed</Text>
								</HStack>
							)}
							{errorCampaigns > 0 && (
								<HStack spacing={1}>
									<WarningTwoIcon boxSize={3} color='red.500' />
									<Text>{errorCampaigns} failed</Text>
								</HStack>
							)}
						</HStack>
					)}
				</Box>

				{/* Campaign List */}
				<Collapse in={isPanelOpen} animateOpacity>
					<VStack
						spacing={3}
						align='stretch'
						maxH='70vh'
						overflowY='auto'
						p={4}
						sx={{
							'&::-webkit-scrollbar': {
								width: '4px',
							},
							'&::-webkit-scrollbar-track': {
								background: 'gray.100',
								borderRadius: 'full',
							},
							'&::-webkit-scrollbar-thumb': {
								background: 'gray.300',
								borderRadius: 'full',
							},
						}}
					>
						{campaigns.map((campaign) => (
							<CampaignCard key={campaign.id} campaign={campaign} />
						))}
					</VStack>
				</Collapse>
			</Box>
		</Box>
	);
};